<template>
  <section class="hero bg-original is-fullheight bg-img-bottom">
    <div class>
      <div class="fullwidth">
        <div class="columns is-vcentered">
          <div class="column is-6" >
            <div class style="margin-top: 100px">
              <div class="text-home">
                <img class="image_Beta" style="width: 7%;" src="../assets/beta.png" />

                <div class="logo-home">
                  <img class="img-symbole" src="../assets/nuha_symbol.png" />
                </div>

                <div class="msg_nlp">
                  <p>Bring Natural Language to your Solutions...</p>
                </div>
              </div>
            <img style="margin-top: 20px;
    margin-left: 20%;
    width: 60%;" src="../assets/iconss.png" />

<!-- 
              <div class="list-panel">
                <ul class="list-icon" style="margin-left: 10%;">
                  <li class="text-center">
                    <img class="image_icon" src="../assets/nuha_assets/nuha_assets01/bot_icon.png" />
                  </li>
                  <li class="text-center">
                    <img
                      class="image_icon"
                      src="../assets/nuha_assets/nuha_assets01/mobile_app_icon.png"
                    />
                  </li>
                  <li class="text-center">
                    <img
                      class="image_icon"
                      src="../assets/nuha_assets/nuha_assets01/home_automation_icon.png"
                    />
                  </li>
                  <li class="text-center">
                    <img
                      class="image_icon"
                      src="../assets/nuha_assets/nuha_assets01/wearable_devices_icon.png"
                    />
                  </li>
                  <li class="text-center">
                    <img class="image_icon" src="../assets/nuha_assets/nuha_assets01/iot_icon.png" />
                  </li>
                </ul>
              </div> -->
              <div class="btn-start">
                <button
                  v-if="!isLoggedIn"
                  @click="login()"
                  class="started"
                  style="margin-left: 23%;"
                >Get Started</button>
                <button v-else @click="bots()" class="started" style="margin-left: 30%;">Get Started</button>
              </div>
            </div>
            <div
              class="list-panel"
              style="display: block;
                    position: absolute;
                    margin-left: 62px;
                    bottom: 1%;"
            >
              <ul class="list-icon">
                <li
                  class="suivre"
                  style="margin-top: 8px;
                    font-size: large;
                    font-weight: bold;"
                >Suivez nous sur</li>
                <li style="margin-left: 10px;max-width: 50%">
                  <a href="https://www.linkedin.com/company/nuha-ai/" target="_blank">
                    <img
                      class="image_lg"
                      style="max-width: 80%"
                      src="../assets/nuha_assets/nuha_assets02/linkedin_icon.png"
                    />
                  </a>
                </li>
                <li style="margin-left: 1px;max-width: 50%">
                  <a href="https://www.facebook.com/argotnlu/" target="_blank">
                    <img
                      class="image_lg;"
                      style="max-width: 80%"
                      src="../assets/nuha_assets/nuha_assets02/facebook_icon.png"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="column is-6" style="padding: 0; height: 93vh;">
            <swiper-slider></swiper-slider>
            <a href="https://www.facebook.com/messages/t/argotnlu" target="_blank">
              <img
                style="position: fixed;
                right: 0%;
                z-index: 1;
                font-size: 40px;
                color: blue;
                bottom: 1.6%;"
                @click="msgsend()"
                class="image_icon"
                src="../assets/msgg.png"
              />
              <!-- <i class="fab fa-facebook-messenger" style="position: fixed;
    right: 3%;
    font-size: 40px;
    color: #0092e0;
    bottom: 5%;"
    
              @click="msgsend()"></i>-->
            </a>
            <p
              style="font-weight: 700;right: 6%;font-size: larger; position: absolute;bottom: 1%; color:#0092e0"
            >Collaborative NLU building Engine for developers</p>
          </div>
        </div>
        <news-letter :id="'newsLetter'" :text="'modal newsLetter'" ></news-letter>
        <contact-as></contact-as>
      </div>
    </div>

  </section>
  
</template>

<script>
const NewsLetter = () =>
  import("@/components/NewsLetter/register.component.vue");

const SwiperSlider = () =>
  import("@/components/Shared/Sliders/sliders.component.vue");
const ContactAs = () =>
  import("@/components/Shared/Contact/contact.component.vue");
const LoginModal = () =>
  import("@/components/Shared/Auth/login.modal.new.component.vue");
const RegisterModal = () =>
  import("@/components/Shared/Auth/register.modal.new.component.vue");
export default {
  components: {
    NewsLetter,
    ContactAs,
    LoginModal,
    RegisterModal,
    SwiperSlider
  },
  data() {
    return {
      propsDatas: {
        title: "Success",
        type: "success",
        direction: "top",
        message: "look at navbar please",
        duration: 1500
      }
    };
  },
  mounted() {
     console.log("IIIIIIIIIIInnnnnndeeeeeeeex");
    
  },
    watch: {
      
   
  },
  computed: {
  
    isLoggedIn() {
      return (
        this.$store.getters.getCurrentUser &&
        this.$store.getters.getCurrentUser.email &&
        this.$store.getters.getCurrentUser.password
      );
    },
    user() {
      return this.$store.getters.getCurrentUser;
    }
  },
  methods: {
    msgsend() {
      console.log("############# send");
    },
    bots() {
      this.$store.dispatch("setAllInfoBotsByUser");
      this.$router.push({
        path: "/application",
        append: true
      });
    },
    newsLetter() {
         this.$hyModal.show("newsLetter");
    
    },
    login() {
      this.$hyModal.show("registration");
      //  this.$hyModal.show("login");
    },
    notif() {
      this.$notif.show(this.propsDatas);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.logo-home

.fullwidth
  flex-grow: 1;
  flex-shrink: 0;
.suivre
  color: white;
  font-weight: bold;
.mr-l-25
  margin-left: 45px

.list-icon
  display: flex;
 

.list-panel
  margin-top: 50px;
  width: 75%;
  margin-left: auto
  margin-right: auto

.name-icon
  line-height: 50px;
  font-weight: 600;
  font-size: 15px;

.image_icon
  height: 70px;
  margin-left: 20px
  

.msg_nlp
  color: #00AEEF;
  font-size: 30px
  font-weight: 750;
  margin-left: 11%;
  margin-bottom: 20px;

.img-symbole
  margin-left: 70px;
  margin-bottom: 10px;
  max-height: 150px;

.img-responsive
  position: absolute;
  bottom: 0px;
  width: 40%;

.started
  background-color: black;
  color: white;
  width: 35%;
  border: transparent;
  box-sizing: border-box;
  height: 45px;
  padding: 7px 24px 8px;
  text-align: center;
  white-space: nowrap;
  background-image: none;
  border-width: 0;
  border-radius: 9px;
  cursor: pointer;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 20px;
  line-height: 16px;
  letter-spacing: .5px
  
.btn-start
  display: flex;
  margin-left: 230px
  align-content: center;
  align-items: center;
  margin-top: 90px;
</style>



// WEBPACK FOOTER //
// src/components/index.vue